import React from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";

const CustomAlert = ({ showCustomeAlertModal, setShowCustomeAlertModal, text, showClassName, iconClassName, isTopUpFailed, setInvalidateSummary, handleReset, pathname }) => {
  const showRetryingUI = pathname === "/customer/profile" && iconClassName === "ti ti-x fs-1";
  return (
    <>
      <Modal show={showCustomeAlertModal} size="sm" centered>
        <div className="modal-simple">
          <div className="modal-content p-3 p-md-3">
            <Modal.Body className="dashboard-cards rounded text-center">
              <button type="button" className="btn-close" aria-label="Close" onClick={() => {
                setShowCustomeAlertModal(false);
                if (isTopUpFailed) {
                  handleReset();
                }
              }} />
              {showRetryingUI ? <div>
                <svg style={{ width: "100px", height: "100px", margin: "1rem", fill: '#ecd847' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg>
                <i className="fa fa-spinner fa-spin"/>
                <h3 className="text-center">Topup processing...</h3>
                <p className="para">
                It is taking longer than usual to confirm with the operator.</p><p style={{ fontSize: '.79rem'}}>We'll notify you of any updates.</p>
                <div><Link onClick={() => setShowCustomeAlertModal(false)}>Close</Link></div>
              </div> : <div className={showClassName} >
                <p>
                  <i className={iconClassName}></i>
                </p>
              </div>}
              {showRetryingUI ? null : <p className="para">{text}</p>}
              {isTopUpFailed && (<div>Do you want to retry? <Link onClick={() => {
                setShowCustomeAlertModal(false);
                setInvalidateSummary(true);
              }}>Retry!</Link></div>)}
            </Modal.Body>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CustomAlert;
